import { useEffect, useState } from "react"
import $http from "../../utils/$http"
import RootStore from "../../stores/RootStore"
import './GeneralTerms.scss'

export const GeneralTerms = () => {
    const rootStore = new RootStore()
    const lang = rootStore.userStore.languageSettings.language
    const [blobUrl, setBlobUrl] = useState<string>('')

    useEffect(() => {
        getFile()
    }, [])

    const getFile = async () => {
        const file = await $http.get<File>(`/file/general-terms?language=${lang}`, 'arraybuffer', 'application/pdf')
        const blob = new Blob([file], { type: 'application/pdf' })
        setBlobUrl(window.URL.createObjectURL(blob))
    }

    return <>
        <div className="generalTermsWrapper">
            <iframe className="pdfWrapper" src={`${blobUrl}#toolbar=0&navpanes=0&scrollbar=0&zoom=120`} width={"1100px"} height={"100%"} />
        </div>
    </>
}